import { render, staticRenderFns } from "./BlocManager.vue?vue&type=template&id=dbb3e57e&lang=pug&"
import script from "./BlocManager.vue?vue&type=script&lang=js&"
export * from "./BlocManager.vue?vue&type=script&lang=js&"
import style0 from "./BlocManager.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbb3e57e')) {
      api.createRecord('dbb3e57e', component.options)
    } else {
      api.reload('dbb3e57e', component.options)
    }
    module.hot.accept("./BlocManager.vue?vue&type=template&id=dbb3e57e&lang=pug&", function () {
      api.rerender('dbb3e57e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/editor/schematic/blocs/BlocManager.vue"
export default component.exports